<template>
  <ContextMenuBase ref="context-menu" direction="row" :width="menuWidth" @close="closeMenu">
    <div v-for="(color, index) in colors" class="color-swatch-container" :key="index"
         :style="{width: swatchSize+'px', height: swatchSize+'px'}" @click="$emit('select-color', color)"
         @mouseover="$emit('hover-color', color)" @mouseout="$emit('reset-color')"
    >
      <div class="color-swatch" :style="{'color': getCorrectedColorName(color), 'background-color': 'currentColor'}">
      </div>
    </div>
  </ContextMenuBase>
</template>

<script>
import ContextMenuBase from "./base/ContextMenuBase";
import { getCorrectedColorName } from '../../utils'

export default {
  name: "ColorContextMenu",
  components: { ContextMenuBase },
  model: {
    prop: "exercise",
  },
  props: {
    colors: {
      type: Array,
      default: function () {return [];},
    },
    swatchSize: {
      type: Number,
      default: 40,
    },
    swatchesPerRow: {
      type: Number,
      default: 3,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    menuWidth: function () {
      return this.swatchSize * this.swatchesPerRow;
    },
  },
  methods: {
    closeMenu: function () {
      this.$store.commit("contextMenu/setOpen", false);
    },
    getCorrectedColorName: function (color) {
      return getCorrectedColorName(color)
    },
  },
  watch: {
    open: function (val) {
      if (val) {
        this.$refs["context-menu"].openMenu();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.color-swatch-container {
  padding: 2px;
  box-sizing: border-box;
  transition-property: padding;
  transition-duration: 0.2s;
  border-radius: 50%;

  &:hover {
    padding: 0;
    z-index: 1;
  }
}

.color-swatch {
  width: 100%;
  height: 100%;
  box-shadow: 0 0 2px 0 currentColor, 1px 1px 3px 1px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid rgba(0,0,0, 0.2);
}
</style>